import {useProductVariables} from "./useProductVariables";
import {useSuspenseQuery} from "@apollo/client";
import {contentService} from "../api/contentService";
import {useMemo} from "react";
import {EmployeeNavigationModel} from "../models/view/employeeNavigationModel";

export const useEmployeeNavigationQuery = () => {
    const {variables} = useProductVariables();

    const {data} = useSuspenseQuery(contentService.product.employeeNavigation, {variables});

    const model = useMemo(() => new EmployeeNavigationModel(data), [data]);

    return {model}
}